// PostMessage helper method to communicate with parent window
export const sendPostMessage = (type: string, data = {}) => {
    try {
        const message = {
            type,
            ...data,
            source: 'dmg-payment-sdk',
            timestamp: new Date().toISOString(),
        }
        // For popup windows, send to window.opener
        if (window.opener && !window.opener.closed) {
            window.opener.postMessage(message, '*')
        }

        // For iframe, send to parent window
        if (window.parent && window.parent !== window) {
            window.parent.postMessage(message, '*')
        }
    } catch (error) {
        console.error('Error sending postMessage:', error)
    }
}
